export const isObject = (v) => {
    const t = typeof v;
    return v !== null && (t === 'object' || t === 'function');
};

export const isFunction = (v) => Boolean(v && v.constructor && v.call && v.apply);
export const isString = (v) => typeof v === 'string' || v instanceof String;
